import { CancelTokenSource } from "axios";
import { iPagination, iPaginationProps } from "../models/iPagination";
import { Guest, iNft } from "../models/iNft";
import { SearchCriteria } from "../../_Web/components/Nav/SearchBox/SearchBoxStay";
import { backendAxios } from "../Services/axios";

export default class NftController {
  private static cancelTokenSource: CancelTokenSource | null = null;
  static async getPaginated(
    params: iPaginationProps,
    cache?: boolean,
  ): Promise<iPagination<iNft>> {
    const response = await backendAxios.get("/nft/paginate", {
      params: {
        ...params,
        cache,
      },
    });
    return response.data;
  }

  static async getNft(id: string): Promise<iNft> {
    const response = await backendAxios.get("/nft/" + id);
    return response.data;
  }

  static async retrieveFromEmailHash(payload: { hash: string }): Promise<iNft> {
    const response = await backendAxios.post(
      "/nft/retrieve-from-hash",
      payload,
    );
    return response.data;
  }

  static async putNftForSale(payload: {
    nftId: string;
    price: number;
  }): Promise<iNft> {
    const response = await backendAxios.post("/nft/sale", payload);
    return response.data;
  }

  static async changeNftPrice(payload: {
    nftId: string;
    price: number;
  }): Promise<iNft> {
    const response = await backendAxios.post("/nft/change-price", payload);
    return response.data;
  }

  static async removeNftFromSale(payload: { nftId: string }): Promise<iNft> {
    const response = await backendAxios.delete("/nft/sale", { data: payload });
    return response.data;
  }

  static async changeGuestsNft(payload: {
    nftId: string;
    guests: Guest[];
  }): Promise<iNft> {
    const response = await backendAxios.post("/nft/change-guests", payload);
    return response.data;
  }

  static async transferNft(payload: { nftId: string; email: string }) {
    const response = await backendAxios.post("/nft/transfer", payload);
    return response.data;
  }

  /*static async searchNft(payload: SearchCriteria): Promise<any> {
    // If there's a pending request, cancel it
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken source
    this.cancelTokenSource = backendAxios.CancelToken.source();

    try {
      const response: backendAxiosResponse<any> = await backendAxios.post(
        "/search",
        payload,
        {
          cancelToken: this.cancelTokenSource.token,
        }
      );

      // Clear the cancel token after the request completes
      this.cancelTokenSource = null;

      return response.data;
    } catch (error: any) {
      if (backendAxios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        // Handle error
        console.error("Error making request:", error);
        throw error; // Re-throw the error if it's not a cancel error
      }
    }
  }*/
  //ToDO: da vedere se si riesce ad abortire le chiamate in pending prima di effettuarne un'altra
  static async searchNft(payload: SearchCriteria) {
    const response = await backendAxios.post("/search", payload);
    return response.data;
  }

  static async getGaranteed(payload: { nftId: string }) {
    const response = await backendAxios.post("/nft/guaranteed", payload);
    return response.data;
  }

  static async getBids(nftId: string) {
    const response = await backendAxios.get(`/nft/${nftId}/bids`);
    return response.data;
  }
}
